import { TermsOfService } from './Terms';
import { PrivacyPolicy } from './Privacy';
import { LEGAL_PATHS } from './config';

export { TermsOfService } from './Terms';
export { PrivacyPolicy } from './Privacy';
export { LegalPage } from './LegalPage';
export { LEGAL_CONFIG, LEGAL_PATHS, TERMS_VERSION } from './config';

const normalize = (pathname) => String(pathname || '').replace(/\/+$/, '').toLowerCase() || '/';

/**
 * Resolves a pathname to a legal document, or null if it is not one.
 *
 * App.js calls this before any authentication work so these pages render for
 * signed-out visitors. Routing lives inside AuthenticatedApp's BrowserRouter,
 * which never mounts for them, so the match is done on the raw pathname here
 * rather than with a route. Firebase Hosting already rewrites all paths to
 * index.html, so deep links reach the app.
 */
export function resolveLegalPage(pathname) {
    switch (normalize(pathname)) {
        case LEGAL_PATHS.terms:
            return <TermsOfService />;
        case LEGAL_PATHS.privacy:
            return <PrivacyPolicy />;
        default:
            return null;
    }
}
